"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NavBar = require("../NavBar/NavBar");
require("./MobileNav.scss");
var _logoIcon = _interopRequireDefault(require("../../images/logo-icon.svg"));
var _user = _interopRequireDefault(require("../../images/user.svg"));
var _downCaretDarkBlue = _interopRequireDefault(require("../../images/down-caret-dark-blue.svg"));
var _useNavigator = _interopRequireDefault(require("../../utils/hooks/useNavigator"));
var _MobileMegaMenu = _interopRequireDefault(require("../MobileMegaMenu/MobileMegaMenu"));
var _MobileMenu = _interopRequireDefault(require("../MobileMenu/MobileMenu"));
var _MobileDashboardMenu = _interopRequireDefault(require("../MobileDashboardMenu/MobileDashboardMenu"));
var _TopMobileNav = _interopRequireDefault(require("./TopMobileNav"));
var _LanguageSelector = _interopRequireDefault(require("../LanguageSelector/LanguageSelector"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MobileNav = props => {
  const {
    navOptions,
    rightLinks,
    disableLogin,
    disableLanguageRegion,
    disableSectorFlyOut,
    handleSectorFlyoutDeployed,
    sectorFlyoutLabel,
    languageSelectorData,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed,
    saveLanguage = () => {},
    loginPage,
    isHidden,
    isAuthenticated,
    userProfile,
    logout,
    login,
    Link,
    authLabels,
    waffleMenu,
    featuredLink,
    closeAllDropDowns,
    disableCartFlyout,
    cartSettings,
    cartData,
    isCartFlyoutActive,
    setCartFlyoutActive
  } = props;
  const {
    mouse,
    hamburgerIsOpen,
    searchFieldValue,
    handleSearchFieldChange,
    handleSearchSubmit,
    searchField,
    closeHamburger,
    isBottomBarActive,
    sectorFlyoutData
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [isOpen, setIsOpen] = (0, _react.useState)(null);
  const [languageSettings, setLanguageSettings] = (0, _react.useState)(languageSelectorData?.settings);
  const {
    isIos
  } = (0, _useNavigator.default)();
  const openDropDown = isOpen => {
    setIsOpen(isOpen);
  };
  const toggleDropDown = nextOpen => {
    if (isOpen === nextOpen) {
      setIsOpen(null);
    } else {
      setIsOpen(nextOpen);
    }
  };
  const closeAll = () => {
    closeHamburger();
    setTimeout(() => {
      setIsOpen(null);
    }, 300);
  };
  const flyoutPaddingClass = isIos && isBottomBarActive ? "ter-mobile-nav__flyout--extra-padding" : "ter-mobile-nav__flyout--regular-padding";
  const generateNavOptions = publicOnly => {
    return navOptions?.filter(option => {
      return publicOnly ? option.isPublicPage ? option.isPublicPage : option : option;
    })?.filter(option => {
      // filter out unusable options
      return option.type === "category" || option.type === "links" || option.type === "link" || option.type === "page" || option.type === "megaNav";
    })?.map((option, index) => {
      if (option.type === "category") {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenu.default, {
          key: option.contentfulId || index,
          isOpen: isOpen === option.contentfulId ? true : false,
          currentOpenMenu: isOpen,
          megaMenuContent: option,
          openDropDown: openDropDown,
          closeDropDown: closeAll,
          links: option.links,
          featuredLinks: option.featuredLinks,
          featuredLinksTitle: option.featuredLinksTitle && option.featuredLinksTitle,
          toggleDropDown: toggleDropDown,
          Link: Link,
          hamburgerIsOpen: hamburgerIsOpen
        });
      } else if (option.type === "links") {
        return /*#__PURE__*/_react.default.createElement(_MobileMenu.default, {
          text: option.text,
          links: option.links,
          key: option.contentfulId || index,
          isOpen: isOpen === option.contentfulId ? true : false,
          currentOpenMenu: isOpen,
          openDropDown: openDropDown,
          closeDropDown: closeAll,
          toggleDropDown: toggleDropDown,
          Link: Link,
          hamburgerIsOpen: hamburgerIsOpen,
          contentfulId: option.contentfulId
        });
      } else if (option.type === "megaNav") {
        const featuredLinks = option?.featuredSection?.promoLink ? [option?.featuredSection?.promoLink] : option?.featuredSection?.links;
        const featuredLinksTitle = option?.featuredSection?.promoLink ? option?.featuredSection?.promoTitle : option?.featuredSection?.title;
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenu.default, {
          key: option.contentfulId || index,
          isOpen: isOpen === option.contentfulId ? true : false,
          currentOpenMenu: isOpen,
          megaMenuContent: option,
          openDropDown: openDropDown,
          closeDropDown: closeAll,
          links: option.links,
          featuredLinks: featuredLinks,
          featuredLinksTitle: featuredLinksTitle,
          featuredPromoImage: option?.navCategoryPromo?.image || null,
          featuredPromoDescription: option?.navCategoryPromo?.description || null,
          featuredPromoPageLink: option?.navCategoryPromo?.pageLink || null,
          featuredPromoTitle: option?.navCategoryPromo?.title || null,
          toggleDropDown: toggleDropDown,
          Link: Link,
          hamburgerIsOpen: hamburgerIsOpen
        });
      } else if (option.type === "link" || option.type === "page") {
        return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
          tabIndex: mouse ? "" : "0",
          depth: 1,
          to: option.url,
          key: option.contentfulId || index,
          className: `ter-mobile-nav__link ${isOpen !== null ? "ter-mobile-nav__link--hidden" : ""} ${!hamburgerIsOpen ? "ter-top-mobile-nav__link-wrapper--hidden" : ""} ${mouse ? "" : "tabFocus"}`,
          onClick: closeAll,
          target: option.type === "link" ? "_blank" : "_self",
          Link: Link,
          isPublicPage: option.isPublicPage
        }, /*#__PURE__*/_react.default.createElement("p", null, option.text));
      }
    });
  };
  const confirmLanguage = region => {
    setLanguageSettings(region);
    saveLanguage(region);
  };
  const myDashboardLabel = authLabels?.myDashboard || "My Dashboard";
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-nav ${hamburgerIsOpen ? "ter-mobile-nav--is-open" : "ter-mobile-nav--is-hidden"} ${!disableSectorFlyOut && hamburgerIsOpen ? `ter-mobile-nav__flyout--active ${flyoutPaddingClass}` : ""}`,
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-mobile-nav__container"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-mobile-nav__menus-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${!hamburgerIsOpen ? "ter-mobile-nav__menus-container--fill--hidden" : ""}
            ${!disableLogin && !isAuthenticated ? "ter-mobile-nav__menus-container--no-fill" : "ter-mobile-nav__menus-container--fill"}`
  }), disableLogin || !disableLogin && isAuthenticated ? generateNavOptions() : generateNavOptions(true)), featuredLink && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    style: {
      visibility: isOpen === null ? "visible" : "hidden",
      transform: isOpen === null ? "translateX(0%)" : "translateX(-100%)",
      transition: "all 0.3s ease"
    },
    to: featuredLink?.url,
    depth: 1,
    tabIndex: mouse ? "" : "0",
    href: featuredLink?.url,
    onClick: () => closeAll,
    className: `ter-top-mobile-nav__link-wrapper ter-top-mobile-nav__link ${mouse ? "ter-navbar__nav-link" : "ter-navbar__nav-link tabFocus"}`,
    Link: Link,
    internalLink: featuredLink?.internalLink,
    ariaLabel: featuredLink?.external === true ? `Open ${featuredLink.text} in a new tab` : null,
    target: typeof featuredLink?.external === "boolean" ? featuredLink?.external ? "_blank" : "_self" : null
  }, featuredLink.text), /*#__PURE__*/_react.default.createElement(_TopMobileNav.default, {
    links: rightLinks,
    handleSearchFieldChange: handleSearchFieldChange,
    searchFieldValue: searchFieldValue,
    handleSearchSubmit: handleSearchSubmit,
    closeAll: closeAll,
    currentOpenMenu: isOpen,
    disableLogin: disableLogin,
    mouse: mouse,
    hamburgerIsOpen: hamburgerIsOpen,
    disableLanguageRegion: disableLanguageRegion,
    languageSelectorData: languageSelectorData,
    languageSelectorDeployed: languageSelectorDeployed,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
    loginPage: loginPage,
    login: login,
    isHidden: isHidden,
    Link: Link,
    isAuthenticated: isAuthenticated,
    userProfile: userProfile,
    logout: logout,
    authLabels: authLabels
  })), sectorFlyoutData?.login && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu ${isOpen !== null ? "ter-mobile-mega-menu--inactive" : ""}`,
    onClick: () => handleSectorFlyoutDeployed()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-mega-menu__name ter-mobile-mega-menu__name__flex ter-mobile-mega-menu__name__utility-link ter-mobile-mega-menu__name--open-parent tabFocus"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _user.default,
    width: "16",
    alt: "User",
    className: "ter-mobile-mega-menu__name__flex__icon"
  }), authLabels?.myAccount || "My Account", /*#__PURE__*/_react.default.createElement("img", {
    className: "ter-mobile-menu__caret ter-mobile-menu__caret--down",
    src: _downCaretDarkBlue.default,
    alt: "caret icon"
  }))), disableCartFlyout === false && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu ${isOpen !== null ? "ter-mobile-mega-menu--inactive" : ""}`,
    onClick: () => setCartFlyoutActive(!isCartFlyoutActive)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-mega-menu__name ter-mobile-mega-menu__name__flex ter-mobile-mega-menu__name__utility-link ter-mobile-mega-menu__name--open-parent tabFocus"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "20",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ter-mobile-mega-menu__name__flex__icon"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41225 2.02226L2.43322 2.02138L2.44517 2.02089L2.48141 2.01945C2.51294 2.01822 2.5583 2.01651 2.61302 2.01461C2.67187 2.01257 2.741 2.01032 2.81497 2.00821C2.82468 2.07349 2.83352 2.13448 2.84103 2.18702C2.84859 2.23995 2.85473 2.28385 2.85896 2.31436L2.8638 2.34942L2.86537 2.36097L2.86819 2.3818L4.61985 12.1911L4.6441 12.3377C4.6594 12.4297 4.68009 12.5532 4.7015 12.6782C4.72275 12.8023 4.74537 12.9317 4.76436 13.034C4.77368 13.0842 4.78332 13.1344 4.7922 13.1764C4.79639 13.1962 4.8024 13.2237 4.80964 13.2521C4.81306 13.2655 4.81949 13.29 4.8286 13.3188C4.82991 13.3232 4.85989 13.4248 4.92495 13.534C5.09241 13.8151 5.342 13.922 5.38939 13.9423L5.39242 13.9436C5.47521 13.9793 5.54536 13.9963 5.5774 14.0035C5.6464 14.019 5.70574 14.0251 5.7328 14.0277C5.79528 14.0336 5.85925 14.0356 5.90687 14.0365C6.00874 14.0385 6.13136 14.0371 6.24057 14.0349C6.35264 14.0326 6.46281 14.0293 6.54418 14.0265L6.64321 14.0229L6.66091 14.0223L16.1412 14.0223C16.6935 14.0223 17.1412 13.5745 17.1412 13.0223C17.1412 12.47 16.6935 12.0223 16.1412 12.0223L6.62075 12.0223L6.61911 12.0223L6.617 12.0096L6.59238 11.8607L6.59121 11.8536L6.2642 10.0223H15.5732C16.5667 10.0223 17.4097 9.29292 17.5524 8.3097L17.9789 5.373C18.1439 4.23704 17.321 3.19563 16.1776 3.0935L4.84616 2.08126L4.84432 2.07095L4.84001 2.03971C4.83546 2.00689 4.82893 1.96021 4.82092 1.90414C4.80496 1.79241 4.78285 1.64149 4.75864 1.48774C4.73484 1.33662 4.70732 1.17185 4.68043 1.03658C4.66746 0.971365 4.65124 0.895577 4.63224 0.825746C4.6233 0.792932 4.60789 0.739399 4.58494 0.68058C4.57363 0.651575 4.55334 0.602675 4.52228 0.546466C4.5004 0.50688 4.42884 0.379647 4.29004 0.261309C4.14554 0.138102 4.00203 0.0875319 3.95909 0.0726921C3.89693 0.0512149 3.84407 0.0394975 3.81318 0.0333338C3.75038 0.020804 3.69415 0.0149392 3.65995 0.0118731C3.58699 0.00533276 3.50837 0.00264453 3.44071 0.00132012C3.30037 -0.0014273 3.12998 0.000480227 2.97369 0.00368696C2.81472 0.00694864 2.65889 0.0118112 2.54355 0.0158197C2.48567 0.0178312 2.43751 0.0196445 2.40366 0.0209617L2.37094 0.0222601H1.14124C0.588951 0.0222601 0.141235 0.469975 0.141235 1.02226C0.141235 1.57454 0.588951 2.02226 1.14124 2.02226H2.41225ZM5.21054 4.12177L5.90705 8.02226L15.5732 8.02226L15.9997 5.08557L5.21054 4.12177ZM5.14124 18C5.14124 16.8954 6.03667 16 7.14124 16C8.2458 16 9.14124 16.8954 9.14124 18C9.14124 19.1046 8.2458 20 7.14124 20C6.03667 20 5.14124 19.1046 5.14124 18ZM14.1412 16C13.0367 16 12.1412 16.8954 12.1412 18C12.1412 19.1046 13.0367 20 14.1412 20C15.2458 20 16.1412 19.1046 16.1412 18C16.1412 16.8954 15.2458 16 14.1412 16Z",
    fill: "#0063A3"
  })), cartSettings?.cartTitle || "My Cart", /*#__PURE__*/_react.default.createElement("img", {
    className: "ter-mobile-menu__caret ter-mobile-menu__caret--down",
    src: _downCaretDarkBlue.default,
    alt: "caret icon"
  }))), sectorFlyoutData?.authenticated && /*#__PURE__*/_react.default.createElement(_MobileDashboardMenu.default, {
    text: myDashboardLabel,
    links: waffleMenu?.links,
    cta: waffleMenu?.cta,
    key: myDashboardLabel,
    isOpen: isOpen === myDashboardLabel,
    currentOpenMenu: isOpen,
    openDropDown: openDropDown,
    closeDropDown: closeAll,
    toggleDropDown: toggleDropDown,
    Link: Link,
    hamburgerIsOpen: hamburgerIsOpen
  }), !disableSectorFlyOut && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-nav__flyout-wrapper ${isOpen !== null ? "ter-mobile-nav__flyout-wrapper--inactive" : ""}`,
    onClick: () => handleSectorFlyoutDeployed()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-nav__flyout-title"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-nav__flyout-title-text"
  }, sectorFlyoutLabel || "Explore Trimble"), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "ter-mobile-nav__flyout-title-icon",
    size: "16px",
    type: "open-caret-right-dark-16px",
    color: "#005f9e"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-nav__flyout-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _logoIcon.default,
    alt: "open flyout"
  }))), languageSelectorData && languageSelectorDeployed && /*#__PURE__*/_react.default.createElement(_LanguageSelector.default, {
    labels: languageSelectorData?.labels,
    settings: languageSelectorData?.settings,
    languages: languageSelectorData?.languages,
    regions: languageSelectorData?.regions,
    languageSelectorDeployed: languageSelectorDeployed,
    saveLanguage: saveLanguage,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed
  }));
};
var _default = MobileNav;
exports.default = _default;